// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

import { LoadingType } from '../../types/Common';
import { LabReviewsStatisticsData, LabReviewsListData } from '../../types/LabReviewsData';

export interface LabReviewsRequestPayload {
  id: string;
  loadingType: LoadingType;
  condition: string;
}
export interface LabReviewsSuccessPayload {
  LabReviewsStatistics: LabReviewsStatisticsData;
  LabReviewsList: LabReviewsListData[];
  id: string;
  loadingType: LoadingType;
}

export interface LabReviewsFailPayload {
  error: Error;
}

export const getLabReviewsActions = createAsyncAction(
  'elearning/GET_LAB_REVIEWS',
  'elearning/GET_LAB_REVIEWS_SUCCESS',
  'elearning/GET_LAB_REVIEWS_FAIL'
)<
  LabReviewsRequestPayload,
  LabReviewsSuccessPayload,
  LabReviewsFailPayload
>();
